class Header {
    constructor(header, options = {}){
        this.options = Object.assign(
            {},
            {    
                
            }, 
            options 
        );   

        header.querySelector("#burger").addEventListener("click", () => {
            header.classList.toggle('menu-open');
            burger.classList.toggle('active');
            document.querySelector("body").classList.toggle('freeze');
            document.querySelector("html").classList.toggle('freeze');  
        });

        if(header.querySelector("#btn-cart") != null){
            header.querySelector("#btn-cart").addEventListener("click", () => {
                cart.openCart();
            });
        }

        window.addEventListener("scroll", (e) => { 
            if(window.scrollY > 0){
                header.classList.add("scrolled"); 
                document.querySelector("#shopify-section-header").classList.add("scrolled"); 
            }else{
                if(header.classList.contains("scrolled")){
                    header.classList.remove("scrolled");
                }
                if(document.querySelector("#shopify-section-header").classList.contains("scrolled")){
                    document.querySelector("#shopify-section-header").classList.remove("scrolled");
                }
            }
        });
    } 
}

const header = new Header(document.querySelector("#header"));